import React, { useState, useEffect } from 'react';
import AddDropBig from './AddDropBig';
import AddDropBigTeachers from './AddDropBigTeacher';
import { Users, UserCog } from 'lucide-react';
import { FiMousePointer } from 'react-icons/fi';
import { gradeApi } from '../../../../api.js';

const CourseManagement = ({ course, class_id, onRosterImported, rosterImported }) => {
  const [activeTab, setActiveTab] = useState('students');

  return (
    <div className="course-management-container overflow-y-auto max-h-[calc(100vh-130px)]">
      <style jsx global>{`
        @keyframes subtle-pulse {
          0% {
            filter: drop-shadow(0 0 12px rgba(228, 177, 122, 0.4));
          }
          50% {
            filter: drop-shadow(0 0 21px rgba(228, 177, 122, 0.7));
          }
          100% {
            filter: drop-shadow(0 0 12px rgba(228, 177, 122, 0.4));
          }
        }

        .pointer-container {
          position: relative;
          animation: move-to-center 3s ease-in-out infinite;
        }

        @keyframes move-to-center {
          0% {
            transform: translate(20px, 20px);
          }
          40% {
            transform: translate(0, 0);
          }
          50% {
            transform: scale(0.9);
          }
          60% {
            transform: translate(0, 0) scale(1);
          }
          100% {
            transform: translate(20px, 20px);
          }
        }

        .mouse-pointer {
          filter: drop-shadow(0 0 1px rgba(228, 177, 122, 0.3));
          animation: pulse-opacity 2s ease-in-out infinite;
        }

        @keyframes pulse-opacity {
          0%,
          100% {
            opacity: 0.8;
          }
          50% {
            opacity: 1;
          }
        }

        .click-ripple-container {
          position: relative;
          animation: click-timing 3s infinite;
        }

        @keyframes click-timing {
          0%,
          45%,
          65%,
          100% {
            opacity: 0;
          }
          50%,
          55% {
            opacity: 1;
          }
        }

        .click-ripple {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(228, 177, 122, 0.6);
          border-radius: 50%;
          transform: scale(0);
          animation: click-ripple 1.5s infinite;
        }

        @keyframes click-ripple {
          0%,
          100% {
            transform: scale(0);
            opacity: 0;
          }
          10% {
            transform: scale(0);
            opacity: 0.8;
          }
          50% {
            transform: scale(10);
            opacity: 0;
          }
        }
      `}</style>

      {/* Course Title with Animation - only shown after roster import */}
      {rosterImported && (
        <div className="px-2 py-4 mb-4">
          <h2
            className="text-xl font-semibold text-gray-800 relative"
            style={{
              position: 'relative',
              filter: 'drop-shadow(0 0 8px rgba(228, 177, 122, 0.6))',
              animation: 'subtle-pulse 2.5s infinite'
            }}
          >
            {course?.name || 'Course Settings'}

            <div
              className="course-name-indicator"
              style={{
                position: 'absolute',
                top: '50%',
                right: '-30px',
                transform: 'translateY(-50%)',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
                zIndex: 20
              }}
            >
              <div className="pointer-container" style={{ position: 'absolute', top: '0px' }}>
                <FiMousePointer
                  className="mouse-pointer"
                  size={18}
                  color="#e4b17a"
                  style={{
                    filter: 'drop-shadow(0 0 3px rgba(228, 177, 122, 0.7))',
                    transform: 'rotate(-5deg)'
                  }}
                />
              </div>

              <div
                className="click-ripple-container"
                style={{
                  position: 'absolute',
                  width: '18px',
                  height: '18px',
                  opacity: 0.9
                }}
              >
                <div className="click-ripple"></div>
              </div>
            </div>
          </h2>
        </div>
      )}

      {/* Tabbed Navigation */}
      <div className="flex border-b border-gray-200 mb-4 sticky top-0 bg-white z-10">
        <button
          className={`py-4 px-8 font-medium text-base focus:outline-none flex items-center gap-2 ${
            activeTab === 'students'
              ? 'border-b-2 border-[#e4b17a] text-[#e4b17a] font-semibold'
              : 'text-gray-600 hover:text-gray-800'
          }`}
          onClick={() => setActiveTab('students')}
        >
          <Users className="w-5 h-5" />
          Students
        </button>
        <button
          className={`py-4 px-8 font-medium text-base focus:outline-none flex items-center gap-2 ${
            activeTab === 'instructors'
              ? 'border-b-2 border-[#e4b17a] text-[#e4b17a] font-semibold'
              : 'text-gray-600 hover:text-gray-800'
          }`}
          onClick={() => setActiveTab('instructors')}
        >
          <UserCog className="w-5 h-5" />
          Instructors
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'students' && (
          <AddDropBig
            class_id={class_id}
            rosterImported={rosterImported}
            onRosterImported={onRosterImported}
          />
        )}
        {activeTab === 'instructors' && <AddDropBigTeachers class_id={class_id} />}
      </div>
    </div>
  );
};

export default CourseManagement;
